<template>
    <v-dialog v-model="dialog" persistent width=80%>
        <v-container style="height:auto; background-color: white;" class="px-8">
        
            <div style="display: flex; flex-direction: row; align-items:baseline ; gap: 10px;">
                <h1>{{ text.type }}</h1> 
                <div>({{ table }})</div> 
                <div style="border: solid 1px; margin-left: 50px; display: flex; flex-direction: row; align-items: center; gap: 10px;" class="rounded py-2 px-3"><img src="@/assets/chatgpt-green.svg" width="30"/>Translations with ChatGPT</div>
            </div>
        
            <div class="mt-6" style="font-weight: 500; font-size: 14pt;">Selected text ({{ text.language }}) - this text will be used as a base for all translations</div>
            <v-textarea v-model="text.text" rows="5" :readonly="true" counter no-resize />

            <div>
                <div style="display: flex; flex-direction: row; align-items: center; gap: 10px;">
                    <div>Target languages</div>
                    <div v-for="lng, index in text.translatableTo" :key="index" style="font-weight: 600;">{{ lng.code }}<span v-if="(index + 1) < text.translatableTo.length">,</span></div>
                    <div style="font-style: italic;">(translation will be made by the system and may take some time)</div>
                </div>
            </div>
            <div style="display: flex; flex-direction: row; gap: 10px; align-items: center; margin-top: 10px; margin-bottom: 10px;">
                <v-spacer></v-spacer>
                <v-btn color="success" @click="translate()" :loading="loading">Translate and save</v-btn>
                <v-btn color="primary" @click="closeDialog()" :disabled="loading">Close</v-btn>
            </div>

        </v-container>
    </v-dialog>        
</template>    

<script>
export default {

    components: {
    },
    data() {
        return {
            dialog: false,
            content: this.value,
            translation_tool: 0,
            loading: false,
            sel_language: '',
            translation: '',
            table: '',
            encrid: '',
            text: {},
        }
    },
    created() {                 
    },
    mounted() {
    },
    computed: {
    },
    methods: {
        open(text, table, encrid) {
            console.log(table)
            this.dialog = true
            this.sel_language = ''
            this.translation = ''
            this.translation_tool = 0
            this.text = text
            this.table = table
            this.encrid = encrid
            this.text.translatableTo.forEach((x, i) => {
                if(x.code === this.text.language)this.text.translatableTo.splice(i, 1)
            })
        console.log(this.table)
        },
        closeDialog() {
            this.dialog = false;
        },
        closeDialogAndSendResult() {
            // translate all tekst and block UI. When done send result            
            this.$emit('updateData', {translate: true})
            this.dialog = false;
        },           
        getLanguage() {
            return this.sel_language===''?'...':this.sel_language
        },
        async translate(){
            this.loading=true
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/autoTranslateReaction.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "translateText"
                    },
                    translateText: {                        
                        sourceLng: this.text.language, 
                        sourceText: this.text.text,
                        targetLanguages: this.text.translatableTo,
                        table: this.table,
                        encrid: this.encrid
                    }
                })
                .then(async res => {
                    console.log(res)
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.loading=false
                        this.closeDialogAndSendResult()
                    }
                });
        }
    }
}    
</script>

<style scoped>
  .radiogroup-font{
      font-size: 18px !important; 
  }
</style>